import { createStyles } from '@material-ui/core';
import { container } from 'assets/jss/material-kit-pro-react.jsx';

const styles = theme =>
  createStyles({
    root: {
      ...container,
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      marginTop: theme.spacing(2)
    }
  });

export default styles;
